import { Component } from 'react';
import { Svg } from '../../Gauge';
import {
   formatLabelIdAndId,
   GAUGE_CENTER_COORDINATES,
   GaugeCoordinates,
   GaugeElementId,
   getValueBasedOnBounds,
   HALF_CIRCLE_DEGREES
} from '../../shared/GaugeShared';
import { GaugeCenterProps } from './GaugeCenter';

export class GaugeCenterArrowGroup extends Component<GaugeCenterProps> {
   private CENTER_ARROW_STROKE_WIDTH = 2;
   private CENTER_ARROW_MOVE_POSITION: GaugeCoordinates = {
      x: 35,
      y: 20
   };

   constructor(props: GaugeCenterProps) {
      super(props);

      this.drawGaugeCenterArrowGroup(props);
      this.rotateGaugeCenterArrowGroup(props);
   }

   render() {
      return null;
   }

   UNSAFE_componentWillReceiveProps(nextProps: GaugeCenterProps): void {
      this.updateGaugeCenterArrowGroupBackgroundColor(nextProps.svg,
                                                      nextProps.svgId,
                                                      nextProps.centerBackgroundColor);
      this.rotateGaugeCenterArrowGroup(nextProps);
   }

   drawGaugeCenterArrowGroup = (props: GaugeCenterProps): void => {
      const centerArrowGroup: any = props.svg.draw.group()
         .attr({
                  id: formatLabelIdAndId(GaugeElementId.ARROW_GROUP, props.svgId)
               });

      this.drawGaugeCenterArrow(props, centerArrowGroup);
      this.drawGaugeCenterArrowSpacer(centerArrowGroup);
   };

   drawGaugeCenterArrow = (props: GaugeCenterProps, centerArrowGroup: any): void => {
      centerArrowGroup.polygon('0,30 15,0 30,30')
         .move(this.CENTER_ARROW_MOVE_POSITION.x, this.CENTER_ARROW_MOVE_POSITION.y)
         .attr({
                  id: formatLabelIdAndId(GaugeElementId.ARROW, props.svgId),
                  fill: props.centerBackgroundColor,
                  stroke: props.centerBackgroundColor,
                  'stroke-width': this.CENTER_ARROW_STROKE_WIDTH,
                  'stroke-linejoin': 'round'
               });
   };

   drawGaugeCenterArrowSpacer = (centerArrowGroup: any): void => {
      centerArrowGroup.rect(100, 100)
         .center(GAUGE_CENTER_COORDINATES.x, GAUGE_CENTER_COORDINATES.y)
         .attr({
                  opacity: 0
               });
   };

   updateGaugeCenterArrowGroupBackgroundColor = (svg: Svg,
                                                 svgId: string,
                                                 backgroundColor: string): void => {
      svg.get(formatLabelIdAndId(GaugeElementId.ARROW, svgId))
         .attr({
                  fill: backgroundColor,
                  stroke: backgroundColor
               });
   };

   rotateGaugeCenterArrowGroup = (props: GaugeCenterProps): void => {
      const degrees: number = this.calculateDegreesForRotationBasedOnValueAndBounds(props.value,
                                                                                    props.lowerBound,
                                                                                    props.upperBound);

      props.svg.get(formatLabelIdAndId(GaugeElementId.ARROW_GROUP, props.svgId)).rotate(180 - degrees);
   };

   calculateDegreesForRotationBasedOnValueAndBounds = (value: number,
                                                       lowerBound: number,
                                                       upperBound: number): number => {
      const range: number = upperBound - lowerBound;
      const degreesIncrement: number = HALF_CIRCLE_DEGREES / range;

      return degreesIncrement * (getValueBasedOnBounds(value, lowerBound, upperBound) - lowerBound);
   };
}
